import { render } from "./EntityDetails.vue?vue&type=template&id=2f6a8f98&ts=true"
import script from "./EntityDetails.vue?vue&type=script&lang=ts"
export * from "./EntityDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__